import { createFileRoute } from "@tanstack/react-router";
import type {} from "@tanstack/react-start";
import { GonePage, goneHandler } from "@/lib/seo/gone";

// Retired: helpline directory hub.
export const Route = createFileRoute("/helpline/")({
  server: { handlers: { GET: goneHandler } },
  component: GonePage,
});
